import { Component, Host, h, Element, Prop } from '@stencil/core';
import { aiIconData } from './icon-data';

export interface AhaAiIcon extends HTMLAhaAiIconElement {}

// Standard AI icon component.
@Component({
  tag: 'aha-ai-icon',
  styleUrl: 'aha-ai-icon.css',
  shadow: true,
})
export class AhaAiIcon {
  @Element() host!: HTMLAhaAiIconElement;

  @Prop({ reflect: true }) disabled: boolean = false;
  @Prop({ reflect: true }) size: number = 17;
  @Prop({ reflect: true }) color: string = 'gradient';

  render() {
    return <Host>{aiIconData(this.size, this.color)}</Host>;
  }
}
